import Api from '../http.service';
/**paymnet by Credit
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.redirectUrl
 * @param {String} payload.data.bookingId
 */
export const PaymentFlight = (payload, paymentType) =>
  Api.POST({
    url: `payment/flight/${paymentType}`,
    data: payload.data,
  });
/**get all Wallet history
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {number} payload.data.amount
 * @param {string} payload.data.currencyId
 * @param {string} payload.data.description
 * @param {string} payload.data.callbackURL
 *
 */
export const charge = (payload) =>
  Api.POST({
    url: 'payment/wallet/deposit',
    data: {
      ...payload.data,
      callBackUrl: `${window.location.origin}/#/payment-result`,
    },
  });
export const paymentResult = (orderId) =>
  Api.GET({
    url: `payment/transaction/order/${orderId}`,
  });

/**
 * insert booking flight
 * @param {Object} payload
 * @param {Number} payload.itemPerPage
 * @param {Number} payload.pageNumber
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 */
export const getAllInvoice = (payload) =>
  Api.GET({
    url: `payment/customer/invoice/all?page=${payload.pageNumber - 1}&size=${
      payload.itemPerPage
    }&where=${payload.data.filter}`,
  });

/**
 * insert booking flight
 * @param {Object} payload
 * @param {Number} payload.itemPerPage
 * @param {Number} payload.pageNumber
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 */
export const getPaidInvoice = (payload) =>
  Api.GET({
    url: `payment/customer/invoice/settled?page=${
      payload.pageNumber - 1
    }&size=${payload.itemPerPage}&where=${payload.data.filter}`,
  });

/**
 * insert booking flight
 * @param {Object} payload
 * @param {Number} payload.itemPerPage
 * @param {Number} payload.pageNumber
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 */
export const getUnpaidInvoice = (payload) =>
  Api.GET({
    url: `payment/customer/invoice/rejected?page=${
      payload.pageNumber - 1
    }&size=${payload.itemPerPage}&where=${payload.data.filter}`,
  });

/**
 * insert booking flight
 * @param {Object} payload
 * @param {Number} payload.itemPerPage
 * @param {Number} payload.pageNumber
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 */
export const getInprogressInvoice = (payload) =>
  Api.GET({
    url: `payment/customer/invoice/inProgress?page=${
      payload.pageNumber - 1
    }&size=${payload.itemPerPage}&where=${payload.data.filter}`,
  });

/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Array} payload.data.invoiceIds
 */
export const payWithWallet = (payload) =>
  Api.POST({
    url: 'payment/customer/invoice/wallet',
    data: {
      invoiceIds: payload.data.invoiceIds,
    },
  });

/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Array} payload.data.invoiceIds
 * @param {Array} payload.data.attachments
 */
export const payWithBankReceipt = (payload) =>
  Api.POST({
    url: 'payment/customer/invoice/attachment',
    data: {
      invoiceIds: payload.data.invoiceIds,
      attachments: payload.data.attachments,
    },
  });

/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Array} payload.data.invoiceIds
 * @param {String} payload.data.redirectUrl
 */
export const paymentGateway = (payload) =>
  Api.POST({
    url: 'payment/customer/invoice/transaction',
    data: {
      invoiceIds: payload.data.invoiceIds,
      redirectUrl: `${payload.data.redirectUrl}/#`,
    },
  });

export const getInvoiceTransaction = (id) =>
  Api.GET({
    url: `payment/customer/invoice/transaction/${id}`,
  });

/**paymnet by Credit
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.redirectUrl
 * @param {String} payload.data.bookingId
 */
export const PaymentFlightTest = (payload, paymentType) =>
  Api.POST({
    url: `payment/flight/${paymentType}`,
    data: payload.data,
  });
